import React from 'react';
import { Checkbox, Spinner } from '@digitools/honest-react';
import { usePost } from 'status/hooks';
import useGet from '../../../../hooks/useGet';
import { themes } from '@digitools/honest-react';
import useTealium from '../../../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';

const WatchlistCheckBox = ({ eventId, eventType, isNewCard, ...rest }) => {
  const { trackEvent } = useTealium();

  const eventValues = {
    eventId,
    eventType,
  };

  const {
    loading: loadingIsWatchlistItem,
    data: isWatchlistItemData,
    get: getIsWatched,
    error: isWatchlistError,
  } = useGet({
    url: '/status-service/watch-list/is-watched',
    options: {
      params: eventValues,
    },
  });

  const success = () => {
    getIsWatched();
  };

  const {
    post: watchlistPost,
    loading: loadingEditWatchlist,
    error: watchlistPostError,
  } = usePost({
    payload: eventValues,
    success,
  });

  const isLoading = loadingEditWatchlist || loadingIsWatchlistItem;

  const handleClick = async () => {
    if (isLoading) {
      return;
    }

    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.CHECKBOX,
      event_type: TEALIUM_EVENT.EVENT_TYPE.WATCHLIST_CHECKBOX,
      event_name: 'Watchlist CheckBox',
    });
    let action = '';

    if (isWatchlistItemData) {
      action = '/remove';
    }

    await watchlistPost({ url: `/status-service/watch-list${action}` });
  };

  return (
    <div aria-busy={isLoading} className='d-flex align-items-center'>
      <Checkbox
        key={`watchlist-${eventId}-${String(isWatchlistItemData)}`}
        field={'watchlist'}
        label={'Watchlist'}
        initialValue={Boolean(isWatchlistItemData)}
        ariaLabel={isWatchlistItemData ? `Remove Leave #${eventId} from watchlist` : `Add Leave #${eventId} to watchlist`}
        onClick={handleClick}
        disabled={isWatchlistError || watchlistPostError}
        theme={themes.rebrand}
        labelVariant={isNewCard ? 'button' : 'default'}
        {...rest}
      />
      {isLoading && (
        <>
          <Spinner
            id='watchlist-checkbox-spinner'
            size='tiny'
            aria-busy='true'
            aria-live='polite'
            style={{
              margin: '0 0 0 0.5rem',
              left: '0%'
            }}
          />
          <span role='status' style={{ opacity: 0, height: 0, overflow: 'hidden', display: 'inline-block' }}>
            Updating watchlist.
          </span>
        </>
      )}
    </div>
  );
};

export default WatchlistCheckBox;
